import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "with-loading" }
const _hoisted_2 = {
  key: 1,
  class: "w-100 text-center border p-4"
}

import { onMounted, ref } from 'vue'
import Loading from './Loading.vue'

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  asyncFunction: () => Promise<any>
  showRetry?: boolean
  showLoading?: boolean
  errorMessage?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WithLoadingPromise',
  props: {
    asyncFunction: null,
    showRetry: { type: Boolean, default: true },
    showLoading: { type: Boolean, default: true },
    errorMessage: { default: window.gettext('An error has occurred') }
  },
  setup(__props: any, { expose }) {

const props = __props as { asyncFunction: () => Promise<any>, showRetry: boolean, showLoading: boolean, errorMessage: string };


const loading = ref(false)
const hasError = ref(false)
const reload = callAsyncFunction

onMounted(callAsyncFunction)

async function callAsyncFunction() {
  loading.value = true
  hasError.value = false
  try {
    await props.asyncFunction()
  } catch (e) {
    console.error(e)
    hasError.value = true
  }
  loading.value = false
}

expose({
  reload,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showLoading && loading.value)
      ? (_openBlock(), _createBlock(Loading, {
          key: 0,
          class: "w-100 text-center pt-2 pb-3"
        }))
      : (hasError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h4", null, _toDisplayString(props.errorMessage), 1 /* TEXT */),
            (props.showRetry)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-danger",
                  onClick: callAsyncFunction
                }, _toDisplayString(_ctx.window.gettext('Retry')), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _renderSlot(_ctx.$slots, "default", { key: 2 })
  ]))
}
}

})